'use strict';

var { once } = require('underscore');

var FAMILIES = {
  'minion-pro-condensed': {
    /**
     * Which characters are missing from the Default set?
     *
     * Minion Pro character map: http://www.linotype.com/172077/MinionProCondensedRegular-product.html
     * Type Tester on Typekit shows characters missing from Default set: https://typekit.com/
     * Useful tool for building Unicode regexes: http://kourge.net/projects/regexp-unicode-block
     */
    trigger: /[\u0100-\u017F\u0180-\u024F\u02B0-\u02FF\u0370-\u03FF\u0400-\u04FF\u1E00-\u1EFF\u1F00-\u1FFF\u2010\u2012\u201a\u2020\u2021\u2022\u2024\u2025\u2030\u2044\u2070-\u209F\u20a1\u20a3\u20a4\u20a7\u20ab\u20b9\u2113\u2116\u2126\u212e\u2150-\u218F\u2190\u2192\u25a0-\u25c9\u2610\u2611\u2713-\u27a2\ue000-\uf7ff\ufb00-\ufb06]/g,
    load: once(window.loadMinionProCondensedFullKit)
  },
  'playfair-display': {
    /**
     * Which characters are missing from the Default set?
     *
     * Minion Pro character map: http://www.linotype.com/172077/MinionProCondensedRegular-product.html
     * Type Tester on Typekit shows characters missing from Default set: https://typekit.com/
     * Useful tool for building Unicode regexes: http://kourge.net/projects/regexp-unicode-block
     */
    trigger: /.*/g,
    load: once(window.loadPlayfairDisplay)
  }
};

var FontLoader = {
  ensureCanRenderString: function (str, family) {
    if (str.match(FAMILIES[family].trigger)) {
      FAMILIES[family].load();
    }
  }
};

module.exports = FontLoader;


/** WEBPACK FOOTER **
 ** ./utils/FontLoader.js
 **/